import React, { useState } from 'react';
import Box from '@mui/material/Box';

import { Typography } from '../Typography/Typography';

import { StyledTabs, StyledTab } from './styles';
import { TabsProps } from './types';

export const Tabs: React.FC<TabsProps> = ({
  tabs,
  tabContent,
  indicatorPosition = 'top',
  initialIndex = 0,
  onChange,
  className,
  variant = 'fullWidth',
}) => {
  const [value, setValue] = useState(initialIndex);

  const handleChange = (_: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
    onChange?.(newValue);
  };

  return (
    <Box className={className}>
      <StyledTabs
        value={value}
        onChange={handleChange}
        indicatorPosition={indicatorPosition}
        variant={variant}
        scrollButtons={variant === 'scrollable' ? 'auto' : false}
      >
        {tabs.map((tab) => (
          <StyledTab
            key={tab.key}
            label={
              <Typography variant="button" i18nKey={tab.i18nKey}>
                {tab.title}
              </Typography>
            }
          />
        ))}
      </StyledTabs>
      <Box mt={2}>{tabContent[tabs[value].key]}</Box>
    </Box>
  );
};
